class Version {
    version: string = "1.0.22";
    build: number = 0;
    suffix: string = "Dev";
}

export default Version;